declare const gsap: any;
declare const ScrollTrigger: any;

import { app, debug } from '../app';
import '../plugins/gsap.min.js';
import '../plugins/ScrollTrigger.min.js';

export class Animations {
    private headerMusicToggle: HTMLElement = document.querySelector('.header-music-toggle');

    constructor() {
        gsap.registerPlugin(ScrollTrigger);
        this.svgAnimations();
        this.homeAnimation();
        this.menuAnimation();
    }

    private svgAnimations():void {
        let svg1 = document.querySelectorAll('#about');
        svg1.forEach((svg) => {
            svg.querySelector('#head-hover').addEventListener('mouseenter', () => {
                gsap.to(svg.querySelector('#head ellipse'), { duration: 0.3, attr: { cx: 844.297, cy: 927.8, rx: 528, ry: 535.2}, ease: 'default' });
            });
            svg.querySelector('#head-hover').addEventListener('mouseleave', () => {
                gsap.to(svg.querySelector('#head ellipse'), { duration: 0.3, attr: { cx: 844.297, cy: 794, rx: 660, ry: 669}, ease: 'default' });
            });
            
            svg.querySelector('#hands-hover').addEventListener('mouseenter', () => {
                gsap.to(svg.querySelector('#hands path'), { duration: 0.3, attr: { d: 'M178.6,4149.7l246.3,-2318l1294.9,0l-220.8,2531.9' }, ease: 'default' });
            });
            svg.querySelector('#hands-hover').addEventListener('mouseleave', () => {
                gsap.to(svg.querySelector('#hands path'), { duration: 0.3, attr: { d: 'M171.3,4189.3 l-67.9,-2384.8 l1363.9,192.3 l212,2505.1' }, ease: 'default' });
            });

            svg.querySelector('#legs-hover').addEventListener('mouseenter', () => {
                gsap.to(svg.querySelector('#legs path'), { duration: 0.3, attr: { d: 'M193.4,8025.3l495.4-3597.9l1022.7,140.8l-495.4,3597.9' }, ease: 'default' });
            });
            svg.querySelector('#legs-hover').addEventListener('mouseleave', () => {
                gsap.to(svg.querySelector('#legs path'), { duration: 0.3, attr: { d: 'M758.3,8252.8l-637.8,-3610.6l1026.3,-181.3l637.8,3610.6' }, ease: 'default' });
            }); 
        });

        let svg2 = document.querySelectorAll('#works');
        svg2.forEach((svg) => {
            svg.querySelector('#rect-hover').addEventListener('mouseenter', () => {
                gsap.to(svg.querySelector('#rect rect'), { duration: 0.3, attr: {height: '3393', y: '288.5'}, ease: 'default' });
            });
            svg.querySelector('#rect-hover').addEventListener('mouseleave', () => {
                gsap.to(svg.querySelector('#rect rect'), { duration: 0.3, attr: {height: '3770', y: '100'}, ease: 'default' });
            });
        });

        let svg3 = document.querySelectorAll('#laboratory');
        svg3.forEach((svg) => {
            const rects = svg.querySelectorAll('div');
            const circles = svg.querySelectorAll('span');
            const windowWidth = window.innerWidth;

            rects.forEach((rect, index) => {
                rect.addEventListener('mouseenter', (event) => {
                    gsap.to(circles[index], { duration: 0.5, x: '-25%', z: '1px', ease: 'default' });
                });
                rect.addEventListener('mouseleave', (event) => {
                    gsap.to(circles[index], { duration: 0.5, x: '-40%', z: '1px', ease: 'default' });
                });
            });
        });

        let svg4 = document.querySelectorAll('#contact');
        svg4.forEach((svg) => {
            const line = svg.querySelector('#line line');
            const windowCenterY = window.innerHeight / 2;

            window.addEventListener('mousemove', (event) => {
                if (event.clientY < windowCenterY) {
                    gsap.to(line, { duration: 0.3, attr: {x1: 1573.4, y1: 282.3, x2: 346.6, y2: 797.7}, ease: 'default' });
                } else {
                    gsap.to(line, { duration: 0.3, attr: {x1: 1576, y1: 791.5, x2: 344, y2: 288.5}, ease: 'default' });
                }
            });
        });
    }

    private homeAnimation():void {
        let songLength:number = 0;
        let documentHeight:number = document.body.clientHeight;
        let windowHeight:number = window.innerHeight;
        let scrollInterval:NodeJS.Timeout;

        const audio = new Audio('/files/pages/43/music.mp3');
        
        const toggleAudio = (stop: boolean = false) => {
            if (!audio.paused || stop === true) {
                audio.pause();
                clearInterval(scrollInterval);
                this.headerMusicToggle.classList.remove('-playing');
            } else {
                audio.play();
                scrollInterval = setInterval(() => {
                    const scrollAmount = (1 - (songLength - audio.currentTime * 1000) / songLength) * (documentHeight - windowHeight);
                    app.scroll.handleScrollTo(scrollAmount);
                }, 50);
                this.headerMusicToggle.classList.add('-playing');
            }
        }
        
        audio.addEventListener("canplaythrough", (event) => {
            songLength = audio.duration * 1000;
            document.querySelector('html').classList.add('-audio-loaded');
        });
        
        this.headerMusicToggle.addEventListener('click', (e: MouseEvent) => {
            toggleAudio();
        });

        app.eventDispatcher.addEventListener('changingPage', (event: CustomEvent) => {
            toggleAudio(true);
        });

        app.eventDispatcher.addEventListener('menuOpened', (event: CustomEvent) => {
            toggleAudio(true);
        });

        window.addEventListener('resize', () => {
            documentHeight = document.body.clientHeight;
            windowHeight = window.innerHeight;
        });

        audio.addEventListener('ended', () => {
            clearInterval(scrollInterval);
        });
    }

    private menuAnimation():void {
        const homeSVG = document.querySelector('.header-home-link svg');
        homeSVG.addEventListener('mouseenter', () => {
            if (app.mq && app.mq !== 'sm' && app.mq !== 'md') {
                gsap.to(homeSVG.querySelector('path'), { duration: 0.3, attr: { d: 'M23,3,0,3V49.7H46V3Z' }, ease: 'default' });
            }
        });
        homeSVG.addEventListener('mouseleave', () => {
            gsap.to(homeSVG.querySelector('path'), { duration: 0.3, attr: { d: 'M23,3,0,18.811V49.7H46V18.811Z' }, ease: 'default' });
        });
    }
}